import { format } from 'date-fns/format';
import { CAT, REFERENCE_TYPE } from './constant';
import { STATUS_FAIL, STATUS_SUCCESS } from 'constants/analyticsConstants';
import {
  SelectedEquipmentInfoProps,
  DealerLocationProps,
  DealerStoreLocationProps
} from './types';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { Equipment } from 'services/equipment/types';
import { equipmentListProps } from '@cat-ecom/pcc-components/src/components/my-equipment/types';

export const getCustomDate = (date = []) => {
  date.sort(
    (a, b) =>
      new Date(a.formattedDate).getTime() - new Date(b.formattedDate).getTime()
  );
  return date
    .map((item) => format(item.formattedDate, 'MM/dd/yyyy'))
    .join(' ; ');
};

export const getRequestPayload = (
  equipmentDetails,
  requestServiceInfo,
  submitterEmail,
  partDetails,
  serviceInsights,
  referenceType,
  dealerLocation
) => {
  const {
    model,
    serialNumber = '',
    productFamily,
    assetId = ''
  } = equipmentDetails;
  const { partName = '', partNumber = '' } = partDetails || {};
  const {
    contactName,
    email,
    companyName,
    contactMethod,
    phone,
    customerName,
    ccidProd
  } = requestServiceInfo.customer;
  const {
    id: serviceInsightsId = '',
    title: serviceInsightsTitle = '',
    impact: serviceInsightsImpact = '',
    dateTime: serviceInsightsDateTime = ''
  } = serviceInsights ?? {};

  const { time, dates = [], type } = requestServiceInfo.preferredDateTime;
  const formattedDates = dates.map(({ formattedDate }) =>
    new Date(formattedDate).toISOString()
  );

  const { requestDealerName, requestDealerCode, requestDescription } =
    requestServiceInfo;
  const equipmentModelFamily = `${model} ${productFamily}`;

  let dealerLocationPayload = dealerLocation;
    if(!dealerLocation?.latitude || !dealerLocation?.longitude ){
    dealerLocationPayload = null;
  }

  const requestPayload = {
    equipmentInfo: {
      assetId: assetId ?? '',
      make: CAT,
      model: model,
      requestReference: serialNumber || equipmentModelFamily
    },
    customerInfo: {
      ccid: ccidProd,
      customerName: customerName,
      submitterEmail: submitterEmail,
      companyName: companyName,
      contactName: contactName,
      contactMethod: contactMethod,
      contactNumber: phone,
      contactEmail: email
    },
    serviceInfo: {
      preferredDateTime: { time: time, dates: formattedDates, type: type },
      ...(dealerLocationPayload && { dealerLocation: dealerLocationPayload }),
      dealerName: requestDealerName,
      dealerCode: requestDealerCode,
      referenceType: referenceType,
      referenceId: serviceInsightsId,
      title: serviceInsightsTitle,
      impact: serviceInsightsImpact,
      softwareName: partName,
      partNumber: partNumber,
      requestDescription: requestDescription,
      dateTime: serviceInsightsDateTime
    }
  };
  return requestPayload;
};

export const getFormeventPayload = (
  formName,
  formData,
  isSuccess,
  fireEvent,
  formAdditionalContent,
  formContent,
  formLocation
) => {
  return fireEvent({
    formName: formName,
    formContent:
      formContent ||
      `time: ${formData.preferredDateTime.type} | contact: ${formData.customer.contactMethod} | dealerName: ${formData.requestDealerName}`,
    formContent2: `Desc: ${formData.requestDescription}`,
    formStatus: isSuccess ? STATUS_SUCCESS : STATUS_FAIL,
    formAdditionalContent,
    formLocation
  });
};

export const getRequestReference = (
  equipmentInfo: SelectedEquipmentInfoProps
) => {
  return (
    equipmentInfo.serialNumber ||
    `${equipmentInfo.model} ${equipmentInfo.productFamily}`
  );
};

export const getSearchPayload = (equipmentInfo, searchType) => {
  return {
    equipmentInfo: equipmentInfo,
    ...(searchType !== REFERENCE_TYPE.GENERAL && { referenceType: searchType })
  };
};

export const getRFSEnabledUser = (userDetails) => {
  return (
    !userDetails.isBuyOnBehalf &&
    !userDetails.isDealerUser &&
    !isEmpty(userDetails.ccidProd)
  );
};

export const getHeight = (list: equipmentListProps[] | Equipment[]) => {
  const height = { 1: '80px', 2: '160px' };
  return height[list.length] ?? '280px';
};

export const getDealerStoreLocationPayload = (
  dealerStoreLocation: DealerStoreLocationProps,
  dealerCode: string
): DealerLocationProps | null => {
  if (!dealerStoreLocation) {
    return null;
  }

  const {
    dealerName: dealerStoreName,
    geo: { latitude, longitude } = {},
    address: {
      line1,
      line2,
      line3,
      city,
      state,
      zipCode,
      countryName,
      country,
      phone: dealerPhone
    } = {}
  } = dealerStoreLocation;

  return {
    dealerCode: dealerCode,
    dealerName: dealerStoreName,
    latitude,
    longitude,
    address: [line1, line2, line3, city, state, zipCode, countryName || country]
      .filter(Boolean)
      .join(', '),
    phone: dealerPhone
  };
};
